const DATA_CONNECTOR_TYPES = {
  CUSTOM: 'custom',
};
export default DATA_CONNECTOR_TYPES;
